import { ChangeDetectionStrategy, Component, contentChild, inject, ViewEncapsulation } from '@angular/core';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { EnpsComponent } from '@common/components/base/enps-component';
import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { ViewStateLayouts } from '@common/enums/viewstate-layouts';
import { ViewStateTypes } from '@common/enums/viewstate-types';
import { LanguageSettings } from '@common/services/language-settings';
import { NavigationService } from '@common/services/navigation-service';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { Store } from '@ngrx/store';
import { ListMainCtaType } from '@src/suite/common/enums/enums';
import { ViewStateService } from '@src/suite/common/services/view-state-service';
import { selectMainCta, selectRightSlot, selectSecondaryCta, selectViewOptions } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { AppService } from '@suite/app.service';

import { CastMainCtaComponent } from './main-cta/cast-main-cta/cast-main-cta.component';
import { LiveMainCtaComponent } from './main-cta/live-main-cta/live-main-cta.component';
import { ManagePublicationChannelsMainCtaComponent } from './main-cta/manage-publication-channels-main-cta/manage-publication-channels-main-cta.component';
import { ManageTeamMembersMainCtaComponent } from './main-cta/manage-team-members-main-cta/manage-team-members-main-cta.component';
import { PlanningViewsMainCtaComponent } from './main-cta/planning-views-main-cta/planning-view-main-cta.component';
import { PlaybookMainCtaComponent } from './main-cta/playbook-main-cta/playbook-main-cta.component';
import { CastRightSlotComponent } from './right-slot/cast-right-slot/cast-right-slot.component';
import { DiscoverRightSlotComponent } from './right-slot/discover-right-slot/discover-right-slot.component';
import { ManageTeamMembersRightSlotComponent } from './right-slot/manage-team-members-right-slot/manage-team-members-right-slot.component';
import { PlaybookRightSlotComponent } from './right-slot/playbook-right-slot/playbook-right-slot.component';
import { CastSecondaryCtaComponent } from './secondary-cta/cast-secondary-cta/cast-secondary-cta.component';
import { DiscoverSecondaryCtaComponent } from './secondary-cta/discover-secondary-cta/discover-secondary-cta.component';
import { LiveSecondaryCtaComponent } from './secondary-cta/live-secondary-cta/live-secondary-cta.component';
import { PlaybookSecondaryCtaComponent } from './secondary-cta/playbook-secondary-cta/playbook-secondary-cta.component';
import { TemplatesSecondaryCtaComponent } from './secondary-cta/templates-secondary-cta/templates-secondary-cta.component';
import { PlaybookViewOptionsComponent } from './view-options//playbook-view-options/playbook-view-options.component';
import { DiscoverViewOptionsComponent } from './view-options/discover-view-options/discover-view-options.component';
import { LiveViewOptionsComponent } from './view-options/live-view-options/live-view-options.component';
import { ManageTeamMembersViewOptionsComponent } from './view-options/manage-team-members-view-options/manage-team-members-view-options.component';
import { TemplatesViewOptionsComponent } from './view-options/templates-view-options/templates-view-options.component';
import { WastebinViewOptionsComponent } from './view-options/wastebin-view-options/wastebin-view-options.component';

@Component({
    selector: 'st-main-content',
    imports: [
        CastMainCtaComponent,
        CastRightSlotComponent,
        CastSecondaryCtaComponent,
        DiscoverRightSlotComponent,
        DiscoverSecondaryCtaComponent,
        DiscoverViewOptionsComponent,
        LiveMainCtaComponent,
        LiveSecondaryCtaComponent,
        LiveViewOptionsComponent,
        ManagePublicationChannelsMainCtaComponent,
        ManageTeamMembersMainCtaComponent,
        ManageTeamMembersRightSlotComponent,
        ManageTeamMembersViewOptionsComponent,
        MatToolbar,
        MatToolbarRow,
        PlanningViewsMainCtaComponent,
        PlaybookMainCtaComponent,
        PlaybookRightSlotComponent,
        PlaybookSecondaryCtaComponent,
        PlaybookViewOptionsComponent,
        TemplatesSecondaryCtaComponent,
        TemplatesViewOptionsComponent,
        WastebinViewOptionsComponent,
    ],
    templateUrl: './main-content.component.html',
    styleUrl: './main-content.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-main-content',
    },
})
export class MainContentComponent extends EnpsComponent {
    nomWebServicesJson = inject(NomWebServicesJson);
    viewStateService = inject(ViewStateService);
    navigationService = inject(NavigationService);
    languageSettings = inject(LanguageSettings);
    appService = inject(AppService);
    listMainCtaType = ListMainCtaType;

    private store = inject(Store);

    public viewStateTypes = ViewStateTypes;
    public viewStateLayouts = ViewStateLayouts;
    public pstFieldNames = PSTFieldNames;

    readonly mainCta = contentChild('mainCta');

    mainCta$ = this.store.selectSignal(selectMainCta);
    secondaryCta$ = this.store.selectSignal(selectSecondaryCta);
    viewOptions$ = this.store.selectSignal(selectViewOptions);
    rightSlot$ = this.store.selectSignal(selectRightSlot);

    public onTileViewPagerChanged(e: any) {
        this.navigationService.currentListView.tileView.startIndex = e.startIndex;
        this.navigationService.currentListView.tileView.pageSize = e.pageSize;
    }

    public onTileViewDateRangePagerChanged(e: any) {
        if (this.navigationService.currentListView.tileView) {
            this.navigationService.currentListView.tileView.firstDay = e.firstDay;
            this.navigationService.currentListView.tileView.lastDay = e.lastDay;
        }
    }
}
